import { resolveTaskId } from './resolveTaskOccurrence';
import request from "../../app/api/requests";

export function addRunTime(payload: { id: string; seconds: number }) {
    return async () => {
        if (!Number.isFinite(payload.seconds) || payload.seconds < 0) throw new Error('Invalid run time');
        const databaseId = await resolveTaskId(payload.id);
        const response = await request.post('/Time/RunTime/', null, {params: {
            TaskId: databaseId, UserId: localStorage.getItem('userID'), Time: Math.floor(payload.seconds),
        }});
        return response.data;
    };
}
